<ng-container *ngIf="{ question: question$ | async, answer: answer$ | async } as data">
  <app-card>
    <div app-card-content class="h-auto">
      <div class="flex">
        <div class="flex w-full justify-start">
          <span class="mr-5 text-lg font-semibold">
            {{ 'gestor-avaliacoes.questao' | translate }} {{ data.question.index + 1 }}
          </span>
          <span class="flex items-center text-gray-400" translate>
            <ng-container *ngIf="isObjective; else discursiveTemplate"> gestor-avaliacoes.tipo.objetiva </ng-container>
            <ng-template #discursiveTemplate> gestor-avaliacoes.tipo.discursiva </ng-template>
          </span>
        </div>
        <div class="flex w-full justify-end">
          <span
            >{{ 'gestor-avaliacoes.peso' | translate }}: {{ data.question.peso | currency : '' : '' : '1.2-2' }}</span
          >
        </div>
      </div>
      <hr app-divider />
      <div class="mt-5 flex w-full pb-5 pt-0">
        <app-accordion class="w-full">
          <app-accordion-item headerClass="!bg-theme-100 ">
            <div app-accordion-header class="flex">
              <svg-icon class="flex h-6" src="assets/icons/icon-pencil.svg"></svg-icon>
              <span class="ml-4 w-full text-lg font-semibold active:text-base-mantis-500" translate>
                gestor-avaliacoes.novas-questoes.enunciado
              </span>
            </div>
            <ng-template app-accordion-lazy>
              <div app-accordion-content class="!border-t-none mb-4 rounded-b-xl border border-gray-200">
                <div class="flex w-full px-6 pb-5">
                  <app-text-editor
                    *ngIf="data.question.enunciado"
                    [readOnly]="true"
                    [value]="data.question.enunciado"
                    [toolbar]="editorConfigToolbar"
                  ></app-text-editor>
                </div>
              </div>
            </ng-template>
          </app-accordion-item>
        </app-accordion>
      </div>

      <!-- Card Resposta do Aluno -->
      <span class="p-1 text-md font-bold" translate> gestor-avaliacoes.resposta-do-aluno-dois-ponto </span>
      <hr app-divider />
      <div class="grid gap-2 pt-5">
        <ng-container *ngIf="hasResponseCard; else answerTemplate">
          <app-response-card-image></app-response-card-image>
        </ng-container>
        <ng-template #answerTemplate>
          <ng-container *ngIf="data.question.tipo === assessmentQuestionType.Objetiva">
            <div
              class="mb-5 rounded-xl border-x border-b border-base-gray-100 bg-base-gray-light-200 p-4 shadow-inner-bg"
            >
              <div class="mb-3 grid w-full" *ngFor="let alternative of data.question.alternativas; let i = index">
                <button
                  *ngIf="onGetClass(data.answer, alternative) as class"
                  [ngClass]="class.button"
                  app-button
                  class="border-1 flex w-full justify-start rounded-md bg-white p-1 shadow-lg transition-all duration-300"
                >
                  <div class="flex w-6">
                    <svg-icon
                      *ngIf="alternative.alternativa_correta"
                      class="flex h-6 w-6 !text-base-mantis-500"
                      [ngClass]="class.icon"
                      src="assets/icons/icon-check-outline.svg"
                    ></svg-icon>
                  </div>
                  <span
                    class="ml-3 mr-3 flex rounded-lg border border-solid bg-white px-2 text-[1.2rem] font-medium shadow-sm shadow-black/40"
                    [ngClass]="class.span"
                  >
                    {{ onGetLetter(i) }}
                  </span>
                  <div class="flex w-full">
                    <span
                      *ngIf="alternative.descricao"
                      class="mb-1 flex w-full items-center text-base"
                      [innerHTML]="alternative.descricao"
                    ></span>
                  </div>
                </button>
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="data.question.tipo === assessmentQuestionType.Discursiva">
            <div
              *ngIf="!!data.answer?.resposta; else emptyAnswerTemplate"
              class="flex w-full items-center justify-between truncate"
            >
              <div class="grid w-full">
                <div class="flex w-full items-center justify-between gap-2">
                  <span class="mb-1 whitespace-pre-wrap text-base" [innerHTML]="data.answer?.resposta"></span>
                </div>

                <div class="w-full">
                  <div class="flex">
                    <ng-container *ngIf="!isPercent">
                      <input
                        [ngClass]="{
                          'border-red-500': form.controls.score.invalid && form.controls.score.touched,
                          'border-gray-200': !form.controls.score.invalid || !form.controls.score.touched
                        }"
                        app-input
                        currencyMask
                        [placeholder]="'gestor-avaliacoes.nota' | translate"
                        #inputScore
                        [formControl]="form.controls.score"
                        [options]="scoreConfig"
                        (keydown.escape)="inputScore.blur()"
                        class="w-full !rounded-r-none md:w-3/12 lg:w-full xl:w-3/12"
                      />
                    </ng-container>
                    <ng-container *ngFor="let scale of SCALES">
                      <ng-container *ngIf="onCalculateScaleScore(data.question.peso, scale.value) as result">
                        <div
                          [ngClass]="{
                            'border-red-500': form.controls.score.invalid && form.controls.score.touched,
                            'border-gray-200': !form.controls.score.invalid || !form.controls.score.touched,
                            '  shadow-inner shadow-black/40 ':
                              (result.score | currency) === (form.value.score | currency)
                          }"
                          class="border-l-none flex !items-center border border-gray-200 bg-gray-200 last:rounded-r-lg"
                        >
                          <button
                            (click)="onSetScore(result.score)"
                            [id]="'btn_' + scale.shortcut"
                            class="mt-3 flex px-3 md:px-5"
                          >
                            <span *ngIf="isPercent; else weightTemplate">
                              {{ scale.value | percent }}
                            </span>
                            <ng-template #weightTemplate>
                              {{ result.score | currency : '' : '' : '1.2-2' }}
                            </ng-template>
                          </button>
                        </div>
                      </ng-container>
                    </ng-container>
                  </div>
                </div>

                <app-form-field class="mt-5 w-full">
                  <label app-label class="text-lg" translate> gestor-avaliacoes.comentario-para-aluno </label>
                  <app-text-editor
                    class="w-full"
                    [formControl]="form.controls.feedback"
                    [toolbar]="editorConfigToolbar"
                  ></app-text-editor>
                </app-form-field>
                <hr app-divider class="mb-5" />
                <div class="flex justify-end">
                  <div class="flex w-full justify-end">
                    <button
                      *ngIf="!data.question.sociodemografica && !data.question.anulado && !data.answer.anulado"
                      #popoverTop
                      app-flat-button
                      type="button"
                      (click)="onOpenAnullQuestion(popoverTop, data.question)"
                      class="bg-base-status-danger text-white"
                      translate
                    >
                      gestor-avaliacoes.anular-resposta
                    </button>

                    <button
                      app-flat-button
                      [disabled]="data.question.loading"
                      (click)="onSave()"
                      class="ml-5 w-6/12 bg-blue-500 text-white md:w-3/12"
                      type="button"
                      translate
                    >
                      geral.salvar

                      <ng-container *ngIf="data.question.loading">
                        <app-skeleton
                          class="ml-5 flex !h-3 !w-0"
                          baseStyle="bg-blue-500"
                          [showLabel]="false"
                        ></app-skeleton>
                      </ng-container>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <ng-template #emptyAnswerTemplate>
              <div class="grid h-auto gap-4 p-5">
                <app-card>
                  <div app-card-content class="h-[200px]">
                    <app-jumbotron [showIcon]="false" translate>
                      <svg-icon class="mb-5 w-10 text-gray-300" src="assets/icons/icon-info-rounded.svg"></svg-icon>
                      <ng-container *ngIf="isOnline; else noImageTemplate">
                        gestor-avaliacoes.status.nao-respondido
                      </ng-container>
                      <ng-template #noImageTemplate> gestor-avaliacoes.sem-imagem </ng-template>
                    </app-jumbotron>
                  </div>
                </app-card>
              </div>
            </ng-template>
          </ng-container>
        </ng-template>
      </div>
    </div>
  </app-card>
</ng-container>
